function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Icon-take a tour");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Icon-take-a-tour",
  transform: "translate(-2.000000, -2.000000)"
}, React.createElement("rect", {
  id: "Rectangle-Copy-32",
  fill: "#D8D8D8",
  opacity: 0,
  x: 0,
  y: 0,
  width: 14,
  height: 14
}), React.createElement("g", {
  id: "noun_guide_1523076-copy",
  opacity: 0.6,
  transform: "translate(2.000000, 2.000000)",
  fill: "#000000",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "Group"
}, React.createElement("path", {
  d: "M5.10869565,0.0398010989 C7.80622717,0.0398010989 10,2.25768352 10,4.98485714 C10,7.71203297 7.80622717,9.92991209 5.10869565,9.92991209 C3.02431739,9.92991209 1.24333043,8.60338462 0.5400815,6.7430989 L1.24320652,6.7430989 C1.90661304,8.23287912 3.38462826,9.26713187 5.10869565,9.26713187 C7.45376522,9.26713187 9.34782609,7.35569231 9.34782609,4.98485714 C9.34782609,2.61402088 7.45376522,0.699141758 5.10869565,0.699141758 C3.30013478,0.699141758 1.76191304,1.83745604 1.15149457,3.44639451 L0.4619565,3.44639451 C1.10312826,1.47016593 2.94216739,0.0398010989 5.10869565,0.0398010989 L5.10869565,0.0398010989 Z M3.93682065,2.67372967 L5.89334239,4.87153846 C6.00093696,4.99147253 6.00093696,5.19459341 5.89334239,5.31452747 L3.93682065,7.51232967 L3.4544837,7.06932967 L4.921875,5.42441758 L2.17391307e-08,5.42441758 L2.17391307e-08,4.76507692 L4.921875,4.76507692 L3.4544837,3.11672418 L3.93682065,2.67372967 Z",
  id: "Shape"
})))));

const SvgHeaderTour = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "10px",
    height: "10px",
    viewBox: "0 0 10 10",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgHeaderTour, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/header-tour.2275e577.svg";
export { ForwardRef as ReactComponent };